import { IUser } from "@/common/entity/User";
import { AppConfigs } from "@/common/entity/AppConfigs";
import { request, UrlPath } from "@/request";

function reqUserInfo(isShowToast: boolean = true): Promise<IUser> {
    return request<IUser>(UrlPath.userInfo, isShowToast);
}

function getUserApiConfigs(isShowToast: boolean = true): Promise<AppConfigs> {
    return request<AppConfigs>(UrlPath.appConfigs, isShowToast);
}

export const UserApi = {
    reqUserInfo,
    getUserApiConfigs
};
